module.exports = __webpack_public_path__ + "img/system40-details.dc9ae433.png";